import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Shelf, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { ExperienceContext } from "@/App/context";
import { ANALYTIC_EVENTS } from "@/App/service";

import { ClientAwareLink } from "../ClientAwareLink";
import { ScreenReader } from "../ScreenReader";
import { ThemedLink } from "../themed";

export const Footer: FC = () => {
  const { t: translate } = useTranslation();
  const {
    hideMemberClaimsPage,
    hideFindBestPricePage,
    hideNearbyPharmaciesPage,
    hideDashboard,
    medicareMaterialId,
    hideMedicareMaterialId,
  } = useContext(ExperienceContext);

  const { isCompressed } = useResponsive({
    isCompressed: {
      mobile: true,
      desktop: false,
    },
  });

  return (
    <Grid style={{ backgroundColor: "white" }}>
      {!isCompressed && <Grid.Span columns={1} />}
      <Grid.Span columns={isCompressed ? 12 : 10}>
        <Shelf style={{ height: 84 }}>
          {!isCompressed && !hideDashboard && (
            <ClientAwareLink analyticsEvent={ANALYTIC_EVENTS.FOOTER_MENU.myRx} to="/">
              {translate("FOOTER.myRx")}
            </ClientAwareLink>
          )}
          {!isCompressed && !hideMemberClaimsPage && (
            <ClientAwareLink analyticsEvent={ANALYTIC_EVENTS.FOOTER_MENU.claimsHistory} to="/claims-history">
              {translate("FOOTER.claimsHistory")}
            </ClientAwareLink>
          )}
          {!isCompressed && !hideNearbyPharmaciesPage && (
            <ClientAwareLink analyticsEvent={ANALYTIC_EVENTS.FOOTER_MENU.nearByPharmacies} to="/nearby-pharmacy">
              {translate("FOOTER.nearbyPharmacies")}
            </ClientAwareLink>
          )}
          {!isCompressed && !hideFindBestPricePage && (
            <ClientAwareLink analyticsEvent={ANALYTIC_EVENTS.FOOTER_MENU.findBestPrice} to="/find-best-price">
              {translate("FOOTER.findBestPrice")}
            </ClientAwareLink>
          )}
          <Shelf.Spacer />
          {medicareMaterialId && !hideMedicareMaterialId && (
            <Body>
              <Semibold>{medicareMaterialId} </Semibold>
            </Body>
          )}
          <Body>
            &copy; Capital Rx, Inc. -{" "}
            <ThemedLink to="https://www.cap-rx.com/legal">
              <ScreenReader>{translate("FOOTER.newWindow")}</ScreenReader>
              {translate("FOOTER.legalNotices")}
            </ThemedLink>
          </Body>
          {isCompressed && <Shelf.Spacer />}
        </Shelf>
      </Grid.Span>
      {!isCompressed && <Grid.Span columns={1} />}
    </Grid>
  );
};
